import { useCallback } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import Dropdown from '@/components/ui/therapist/Dropdown';
import { capitalizeWords } from '@/utils/capitalize';
import colors from '@/config/colors';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import RadioButton from '@/components/ui/therapist/RadioButton';
import { Icon } from '@/components/Icon';
import { Input } from '@/components/ui/therapist/Input';
import { styles } from './styles';

const label = {
  text: 'Texte suchen',
  sentence: 'Sätze suchen',
  word: 'Wörter suchen',
};

const termTypes = {
  text: [
    {
      name: 'Textsuche',
      value: 'text',
    },
    {
      name: 'Kategoriesuche',
      value: 'tag',
    },
  ],
  sentence: [
    {
      name: 'Textsuche',
      value: 'sentence',
    },
    {
      name: 'Kategoriesuche',
      value: 'tag',
    },
  ],
  word: [
    {
      name: 'Wortsuche',
      value: 'word',
    },
    {
      name: 'Kategoriesuche',
      value: 'tag',
    },
  ],
};

interface SecondHeaderProps {
  term: string;
  termType: string;
  changeOuterState: (key: string, value: any) => void;
  tags: string[];
  type: 'text' | 'sentence' | 'word';
}

export function SecondHeader({
  term,
  termType,
  changeOuterState,
  tags,
  type,
}: SecondHeaderProps) {
  const data = tags.map((tag: string) => {
    return {
      label: capitalizeWords(tag),
      value: tag,
    };
  });

  const handleTermChange = useCallback((value: string) => {
    changeOuterState('term', capitalizeWords(value));
  }, []);

  const handleTermClear = useCallback(() => {
    handleTermChange('');
  }, []);

  const handleTermTypeChange = useCallback((name: string, value: string) => {
    return () => {
      changeOuterState(name, value);
      handleTermChange('');
    };
  }, []);

  return (
    <View style={styles.secondHeader}>
      <Text style={[styles.marginRight, styles.secondHeaderTitle]}>
        {label[type]}
      </Text>
      {termType !== 'tag' ? (
        <View style={[styles.input, styles.marginRight]}>
          <Input
            value={term}
            placeholder={termTypes[type][0].name}
            placeholderTextColor={colors.newUI.therapist.grey70}
            style={styles.textInput}
            onChange={handleTermChange}
          />
          <PressableNeolexon
            onPress={handleTermClear}
            style={styles.closeButtonParent}
          >
            <Icon name="close" size={24} color={colors.darkGrey} />
          </PressableNeolexon>
        </View>
      ) : (
        <View style={[styles.dropDownContainer, styles.marginRight]}>
          <Dropdown
            search={true}
            customStyles={{ minWidth: '100%', marginBottom: 0 }}
            data={data}
            placeholder="Kategorie auswählen"
            value={!term ? undefined : [(term || '').toLowerCase()]}
            labelField="label"
            valueField="value"
            onSelectChange={(item) => {
              handleTermChange(item[0]);
            }}
          />
        </View>
      )}
      <View style={styles.radioContainer}>
        {termTypes[type].map((eachTermType) => {
          return (
            <View key={eachTermType.name} style={{ marginHorizontal: 16 }}>
              <RadioButton
                onPress={handleTermTypeChange('termType', eachTermType.value)}
                label={eachTermType.name}
                isSelected={termType === eachTermType.value}
                labelStyle={{ fontWeight: '600' }}
              />
            </View>
          );
        })}
      </View>
    </View>
  );
}
